export const decodeTokenPayload = (token) => {
  if (!token) return null;

  try {
    const raw = token.startsWith("Bearer ")
      ? token.slice(7).trim()
      : token.trim();
    const parts = raw.split(".");
    if (parts.length < 2) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");
    const decoded =
      typeof window !== "undefined" && window.atob
        ? window.atob(padded)
        : Buffer.from(padded, "base64").toString("binary");

    const jsonPayload = decodeURIComponent(
      decoded
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.warn("Failed to decode JWT", error);
    return null;
  }
};
